/**
 * Hoarding: Discounted Price (per 10-day block) × day-block multiplier, summed across selected sites.
 *
 * Day-block multiplier (tenBlockFactor): 10 days → ×1, 20 → ×2, 30 → ×3.
 * "Per unit" = the number of selected hoarding sites, captured by summing per-site totals.
 *
 *   Per site:     DiscountedPrice × tenBlockFactor(days)
 *   Grand total:  (Σ DiscountedPrice over selected sites) × tenBlockFactor(days)
 *                 (duration is synced across selected sites, so the first row's value applies to all)
 */
import { tenBlockFactor } from './multipliers';

export function calculateHoardingTotal(variant, selection) {
  const hoardingList = selection?.HoardingList || [];
  if (hoardingList.length === 0) return 0;

  const sumDiscountedMRP = hoardingList.reduce((sum, item) => sum + (Number(item?.DiscountedPrice) || 0), 0);
  const selectedDurationDays = Number(hoardingList[0]?.selectedDuration) || 0;
  return sumDiscountedMRP * tenBlockFactor(selectedDurationDays);
}

/**
 * Single hoarding row total: DiscountedPrice (per 10-day block) × tenBlockFactor(days).
 * `variant` is kept for call-site compatibility but is not used.
 */
export function calculateHoardingRowTotal(discountedPrice, selectedDurationDays, variant) {
  return (Number(discountedPrice) || 0) * tenBlockFactor(selectedDurationDays);
}
